import React from 'react';
// import ReactDOM from 'react-dom';
import {createRoot} from 'react-dom/client'
import App from './App';
import * as serviceWorker from './serviceWorker'
import 'core-js/fn/object/assign';
import 'core-js/fn/promise';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement)

root.render(
        <App />
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
